import { render, staticRenderFns } from "./JobInfo.vue?vue&type=template&id=d80c6ae4&"
import script from "./JobInfo.vue?vue&type=script&lang=js&"
export * from "./JobInfo.vue?vue&type=script&lang=js&"
import style0 from "./JobInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports